<template>
  <v-container fluid class="user-list">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1 px-3 py-4" elevation="0">
        <v-card-text>
          <v-row no-gutters align="center" width="100%">
            <div class="search-input-container">
              <v-text-field
                class="search-input"
                background-color="bgDefault"
                height="55px"
                single-line
                flat
                solo
                
                hide-details
                @keyup="filtersOffers"
                v-model="searchOffer"
                :placeholder="languageData.search"
                :label="languageData.search"
                prepend-inner-icon="mdi-magnify"></v-text-field>
            </div>
            <div class="search-button-container mb-1">
              <v-btn to="/offers/add" color="primary" height="55px" width="100%" class="search-button" >
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $vuetify.breakpoint.xsOnly ? languageData.btnAdd : languageData.btnAddText }}
              </v-btn>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-data-table
            loading-text="Loading... Please wait"
            class="users-table"
            :search="searchOffer"
            :headers="headers"
            :options.sync="pagination"
            :server-items-length="totalItems"
            :items-per-page-options="rowsPerPageItems"
            :footer-props="footerOptions"
            :page.sync="currentPage"
            :items="dataReceive"
            :loading="loadingOffers"
            >
            <template v-slot:item.status="{ item }">
              <v-chip v-if="languageData.offerStatusTypes"
                    outlined
                    :color="assignChip(item.status).color"
              >
                  {{ languageData.offerStatusTypes[item.status] }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }" v-if="languageData.operation && layout !== 'projectForm'">
              <td class="justify-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="previewOffer(item.id)"
                        :disabled="item.status === getAcceptedValue()"
                        icon>
                      <v-icon color="fontDefault">preview</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.operation.preview }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="editOffer(item.id)"
                        icon
                        :disabled="item.status === getAcceptedValue()"
                    >
                      <v-icon color="fontDefault">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.operation.edit }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        :loading="downloadedOffers.includes(item.id)"
                        @click="downloadOffer(item)"
                        icon>
                      <v-icon 
                        color="fontDefault"
                      >mdi-file-download</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.labels.download }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="showEmailForm(item)"
                        icon>
                      <v-icon color="fontDefault">mdi-email-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.labels.typeEmail }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="showDeleteOfferModal(item)">
                      <v-icon color="fontDefault">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.operation.delete }}</span>
                </v-tooltip>
                <v-btn v-if="item.status === getPendingValue()"
                        color="green"
                        class="ma-2 white--text"
                        @click="showModalToAcceptOffer(item)"
                >
                  {{ languageData.btnAccept }}
                </v-btn>
                <v-btn v-if="item.status === getPendingValue()"
                        color="error"
                        class="ma-2 white--text"
                        @click="showDeclineOfferModal(item)"
                >
                  {{ languageData.btnDecline }}
                </v-btn>

              </td>
            </template>
            <template v-slot:item.actions="{ item }" v-else>
                <v-btn
                    :loading="item.id === isEstimationImporting[isEstimationImporting.indexOf(item.id)]"
                    @click="showImportModal(item)"
                    color="primary">
                  {{ languageData.btnImport }}
                </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <template v-if="languageData.modalDelete && languageData.modalDecline">
      <ModalInfo
          :typeInfo="modalDeleteInfoData.typeInfo"
          :headModal="modalDeleteInfoData.head"
          :btnAgreeText="languageData.btnAgreeText"
          @clicked="hideModalDeleteInfo"
          :show-modal="isShowDeleteModalInfo"
          :text-modal="modalDeleteInfoData.textInfo"></ModalInfo>
      <ModalInfo
          @doOperation="deleteOffer"
          :isLoadingBtn="false"
          :idData="modalDeleteData.idData"
          :typeInfo="modalDeleteData.typeInfo"
          :headModal="modalDeleteData.head"
          :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText"
          :btnAgreeText="languageData.btnAgreeText"
          :visDisAgreeBtn="true"
          @clicked="hideModalDelete"
          :show-modal="isShowDeleteModal"
          :text-modal="modalDeleteData.textInfo"></ModalInfo>
      <ModalInfo
          :typeInfo="modalDeclineInfoData.typeInfo"
          :headModal="modalDeclineInfoData.head"
          :btnAgreeText="languageData.btnAgreeText"
          @clicked="hideModalDeclineInfo"
          :show-modal="isShowDeclineModalInfo"
          :text-modal="modalDeclineInfoData.textInfo"></ModalInfo>
      <ModalInfo
          @doOperation="declineOffer"
          :isLoadingBtn="false"
          :idData="modalDeclineData.idData"
          :typeInfo="modalDeclineData.typeInfo"
          :headModal="modalDeclineData.head"
          :btnDisAgreeText="languageData.modalDecline.btnDisAgreeText"
          :btnAgreeText="languageData.btnAgreeText"
          :visDisAgreeBtn="true"
          @clicked="hideModalDecline"
          :show-modal="isShowDeclineModal"
          :text-modal="modalDeclineData.textInfo"></ModalInfo>
    </template>
    <ModalInfo
        :typeInfo="modalSaveInfoData.typeInfo"
        :headModal="modalSaveInfoData.head"
        :btnAgreeText="languageData.btnAgreeText"
        @clicked="hideModalSaveInfo"
        :show-modal="isShowSaveModalInfo"
        :text-modal="modalSaveInfoData.textInfo"></ModalInfo>
    <ModalInfo
        :typeInfo="typeInfoOfferAccept"
        :headModal="headInfoOfferAccept"
        :btnAgreeText="languageData.btnAgreeText"
        @clicked="hideModalAcceptInfo"
        :show-modal="isOfferAccept"
        :text-modal="textInfoOfferAccept"></ModalInfo>
    <ModalInfo :layout="'modalProjectForm'" persistent :hidden-agree-btn="true" @clicked="hideModalShowProjectForm" :show-modal="showProjectFormModal">
      <template v-slot:body>
        <ProjectsForm v-if="showProjectFormModal" isOffer :layout="'add'" :offerData="offerData"></ProjectsForm>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" @clicked="hideModalWithSelectOrCreateProject" :show-modal="showModalWithSelectOrCreateProject" :headModal="languageData.chooseOrCreateProject">
      <template v-slot:body>
        <v-row justify="center" class="mt-2 mb-1">
          <v-btn
            color="primary"
            outlined
            class="mr-4 mb-3"
            @click="selectExistingProjectToAcceptOffer"
            >
          {{ languageData.selectExistingProject }}
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            @click="createNewProjectAndAcceptOffer">
          {{ languageData.createNewProject }}
          </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" @clicked="hideModalWithSelectProject" :show-modal="showModalWithSelectProject" :headModal="languageData.selectProject">
      <template v-slot:body>
        <v-row class="mt-2 px-3">
          <v-select
              outlined
              :label="languageData.selectProject"
              :items="projects"
              v-model="selectedProject"
              item-text="name"
              item-value="id"
              return-object
          >
          </v-select>
        </v-row>
        <v-row justify="center" class="mt-2 mb-2">
          <v-btn
            color="primary"
            class="mr-4"
            @click="acceptOfferWithExistingProject"
            :disabled="!selectedProject"
            >
          {{ languageData.acceptOffer }}
          </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" @clicked="hideWarningModalAboutOverwrittingEstimation" :show-modal="showWarningModalAboutOverwrittingEstimation" :headModal="languageData.attentionHead" :text-modal="languageData.warningTextAboutOverwritingEstimation">
      <template v-slot:body>
        <v-row justify="center" class="mt-4">
            <v-btn
            color="primary"
            outlined
            class="mr-4"
            @click="cancelAcceptOfferWithExistingProject"
            >
          {{ languageData.cancel }}
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            @click="continueAcceptOfferWithExistingProject">
          {{ languageData.continueBtn }}
          </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo
        @doOperation="acceptCloseProjectFormModal"
        :isLoadingBtn="false"
        :typeInfo="'red'"
        :headModal="languageData.headInfoModalClosing"
        :btnDisAgreeText="languageData.btnStay"
        :btnAgreeText="languageData.btnCloseModal"
        :visDisAgreeBtn="true"
        @clicked="hideCloseProjectFormModal"
        :show-modal="showCloseProjectFormModal"
        :text-modal="languageData.textInfoModalClosing"></ModalInfo>
    <ModalInfo v-if="layout === 'projectForm'"
        @doOperation="importEstimationFromOffer(modalImportData.item)"
        :isLoadingBtn="false"
        :typeInfo="'info'"
        :headModal="languageData.modalImport.head"
        :btnDisAgreeText="languageData.modalImport.btnDisAgreeText"
        :btnAgreeText="languageData.modalImport.btnAgreeText"
        :visDisAgreeBtn="true"
        @clicked="hideImportModal"
        :show-modal="isShowImportModal"
        :text-modal="languageData.modalImport.textInfo"></ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import router from "../../../../../router";
import offerStatusTypes from "../../enums/offerStatusTypes";
import offerStatusHelper from "../../../../helpers/offerStatusHelper";
import downloadFileHelper from "../../../../helpers/downloadFileHelper";

export default {
    name: "ListOffers",
    components: {
      ModalInfo,
      ProjectsForm: () => import("../../../Projects/components/ProjectsForm/ProjectsForm")
    },
    props: {
      layout: String,
    },
    data() {
      return {
        searchOffer: null,
        footerOptions: {
          'items-per-page-options': [10, 15, 30],
          'disablePagination': false
        },
        currentPage: 1,
        modalSaveInfoData: {},
        modalAcceptInfoData: {},
        isShowSaveModalInfo: false,
        offerStatusTypes: offerStatusTypes,
        showProjectFormModal: false,
        offerData: {},
        acceptedOfferData: {},
        getAcceptedValue: offerStatusHelper.getAcceptedValue,
        getDeclinedValue: offerStatusHelper.getDeclinedValue,
        getPendingValue: offerStatusHelper.getPendingValue,
        isShowDeclineModalInfo: false,
        modalDeclineInfoData: {},
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: null,
          text: null,
          corner: null,
          timeout: 7500,
          title: null,
          visible: false
        },
        showCloseProjectFormModal: false,
        downloadedOffers: [],
        searchTask: null,
        searchDebouceTime: 500,
        isShowImportModal: false,
        modalImportData: {},
        showModalWithSelectOrCreateProject: false,
        showModalWithSelectProject: false,
        showWarningModalAboutOverwrittingEstimation: false,
        activeItem: null,
        selectedProject: null,
      }
    },
    computed: {
      ...mapState("getOffers", {
        dataReceive: state => state.dataReceive,
        headers: state => state.headers,
        totalItems: state => state.pagination.totalItems,
        rowsPerPageItems: state => state.pagination.rowsPerPage,
        sortBy: state => state.pagination.sortBy,
        loadingOffers: state => state.loadingOffers
      }),
      ...mapState("deleteOffer", {
        isShowDeleteModal: state => state.isShowDeleteModal,
        isLoadingDeleteModal: state => state.isLoadingDeleteModal,
        isShowDeleteModalInfo: state => state.isShowDeleteModalInfo,
        modalDeleteData: state => state.modalDeleteData,
        modalDeleteInfoData: state => state.modalDeleteInfoData
      }),
      ...mapState("acceptOffer", {
        dataAcceptIsFetching: state => state.dataAcceptIsFetching,
        typeInfoOfferAccept: state => state.typeInfoOfferAccept,
        headInfoOfferAccept: state => state.headInfoOfferAccept,
        isOfferAccept: state => state.isOfferAccept,
        textInfoOfferAccept: state => state.textInfoOfferAccept,
        preparedOfferData: state => state.preparedOfferData,
      }),
      ...mapState("declineOffer", {
        isShowDeclineModal: state => state.isShowDeclineModal,
        isLoadingDeclineModal: state => state.isLoadingDeclineModal,
        modalDeclineData: state => state.modalDeclineData,
      }),
      ...mapState("importEstimation", {
        isEstimationImporting: state => state.isEstimationImporting
      }),
      ...mapState("getProjects", {
        projects: state => state.dataReceive,
      }),
      ...mapState("sendOffer", {
        isOfferSended: state => state.isOfferSended,
      }),

      pagination: {
        set: function(value) {
          this.searchOffers(value);
        },
        get: function() {
          return this.$store.state.getOffers.pagination;
        }
      }
    },
    methods: {
      ...mapActions("getOffers", ["getOffers", "getHeadersOfferTable"]),
      ...mapActions("deleteOffer", ["deleteOfferRequest", "showModalDeleteData", "hideModalDeleteAction", "hideModalDeleteInfoAction"]),
      ...mapActions("acceptOffer", ["acceptOfferProjectData", "updateVisibleModal", "prepareOfferData", "acceptOfferToExistingProject"]),
      ...mapActions("declineOffer", ["declineOfferRequest", "showModalDeclineData", "hideModalDeclineAction", "hideModalDeclineInfoAction"]),
      ...mapActions("pendingOffer", ["pendingOfferRequest"]),
      ...mapActions("generateOffer", ["getOfferPdf"]),
      ...mapActions("getProjects", ["getProjects"]),
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),
      ...mapActions("manageEmailForm", ["setDocumentType", "setDocumentId", "updateIsEmailFormVisible"]),
      ...mapActions("sendOffer", ["updateIsOfferSended"]),

      showEmailForm(offer) {
        this.setDocumentType('offer');
        this.setDocumentId(offer.id);
        this.updateIsEmailFormVisible(true);
      },

      hideModalWithSelectOrCreateProject() {
        this.showModalWithSelectOrCreateProject = false;
      },

      hideModalWithSelectProject() {
        this.showModalWithSelectProject = false;
      },

      showModalToAcceptOffer(item) {
        this.activeItem = item
        this.showModalWithSelectOrCreateProject = true;
      },

      createNewProjectAndAcceptOffer() {
        this.showModalWithSelectOrCreateProject = false;
        this.acceptOffer(this.activeItem);
      },

      selectExistingProjectToAcceptOffer() {
        this.getProjects({
          all: true
        });
        this.showModalWithSelectOrCreateProject = false;
        this.showModalWithSelectProject = true;
      },

      hideWarningModalAboutOverwrittingEstimation() {
        this.showWarningModalAboutOverwrittingEstimation = false;
      },

      acceptOfferWithExistingProject() {
        this.showWarningModalAboutOverwrittingEstimation = true;
      },

      cancelAcceptOfferWithExistingProject() {
        this.showWarningModalAboutOverwrittingEstimation = false;
      },

      continueAcceptOfferWithExistingProject() {
        this.showWarningModalAboutOverwrittingEstimation = false;
        this.showModalWithSelectProject = false;
        let creds = {
          project: this.selectedProject,
          offerData: this.activeItem,
        };
        this.acceptOfferToExistingProject({creds: creds})
      },

      getSnackBar: function(title, message, icon, color) {
        this.snackbar = {
          color: color,
          icon: icon,
          mode: "multi-line",
          position: "top",
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
      downloadOffer(item) {
        let id = item.id;
        this.downloadedOffers.push(id);
        let operation = "download";
        this.getOfferPdf({ creds: { id, operation } });
      },
      hideModalDelete: function() {
        this.hideModalDeleteAction();
      },
      hideModalDeleteInfo: function() {
        this.hideModalDeleteInfoAction();
      },
      hideModalDecline: function() {
        this.hideModalDeclineAction();
      },
      hideModalDeclineInfo: function() {
        this.isShowDeclineModal = false;
      },
      filtersOffers: function() {
        clearTimeout(this.searchTask);
        this.searchTask = setTimeout(() => {this.searchOffers({}, true)}, this.searchDebouceTime);
      },
      searchOffers: function(valueSearch={}, filters=false) {
          valueSearch.language = this.getCurrentLanguage;
          valueSearch.filters = filters;
          valueSearch.search = this.searchOffer;
          this.getOffers({valueSearch});
          if(filters) {
            this.currentPage = 1;
          }
      },
      hideModalSaveInfo: function() {
        this.isShowSaveModalInfo = false;
      },
      showDeleteOfferModal: function(item) {
        let modalDeleteData = {};
        modalDeleteData.name  = item.name;
        modalDeleteData.id = item.id;
        modalDeleteData.index = this.dataReceive.indexOf(item);
        modalDeleteData.languageData = this.languageData.modalDelete;
        this.showModalDeleteData(modalDeleteData);
      },
      showDeclineOfferModal: function(item) {
        let modalDeclineData = {};
        modalDeclineData.name  = item.name;
        modalDeclineData.id = item.id;
        modalDeclineData.index = this.dataReceive.indexOf(item);
        modalDeclineData.languageData = this.languageData.modalDecline;
        this.showModalDeclineData(modalDeclineData);

      },
      deleteOffer: function(value) {
        this.deleteOfferRequest(value);
      },
      editOffer: function(id) {
        router.push({ path:"/offers/edit", query: { id: id } });
      },
      previewOffer: function(id) {
        router.push({ path:"/offers/edit", query: { id: id } });
      },
      assignChip(status) {
        return this.offerStatusTypes.find(el => el.value === status)
      },
      acceptOffer(item) {
        this.showProjectFormModal = true;
        item.client.disableSelect = true;
        this.prepareOfferData(item);
        this.offerData = {
          clientsId: [this.preparedOfferData.client.id],
          clients: [this.preparedOfferData.client],
          clientsTypes: [
            {
              id: this.preparedOfferData.client.id,
              clientType: parseInt(Object.keys(this.languageData.clientTypes).find(key => this.languageData.clientTypes[key] === "PRINCIPAL")),
            }
          ]
        };
      },
      pendingOffer(item) {
        this.pendingOfferRequest(item.id);
      },
      declineOffer(value) {
        this.declineOfferRequest(value)
      },
      hideModalShowProjectForm() {
        this.showCloseProjectModalWarning();
      },
      hideModalAcceptInfo() {
        this.updateVisibleModal(false);
      },
      hideCloseProjectFormModal() {
        this.showCloseProjectFormModal = false;
      },
      showCloseProjectModalWarning() {
        this.showCloseProjectFormModal = true;
      },
      acceptCloseProjectFormModal() {
        this.showProjectFormModal = false;
      },
      importEstimationFromOffer(item) {
        eventBus.$emit('importEstimation', item);
      },
      showImportModal(item) {
        this.modalImportData.item = item;
        this.modalImportData.languageData = this.languageData.modalImport;
        this.isShowImportModal = true;
      },
      hideImportModal() {
        this.isShowImportModal = false;
      }
    },
    mounted() {
      if(localStorage.getItem("textOfferSave")) {
        this.modalSaveInfoData.typeInfo = "success";
        this.modalSaveInfoData.textInfo = localStorage.getItem("textOfferSave");
        this.modalSaveInfoData.head = localStorage.getItem("messageOfferSave");
        this.isShowSaveModalInfo = true;
        localStorage.removeItem("textOfferSave");
        localStorage.removeItem("messageOfferSave");
      }
      const language = this.getCurrentLanguage;
      this.getHeadersOfferTable({creds: {language}});
      eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeadersOfferTable({creds: {language}});
      });
      eventBus.$on("deleteItemSuccess", () =>{
        this.searchOffers();
      });
      eventBus.$on("setDisablePagination", (value) => {
        this.footerOptions["disablePagination"] = value;
      });
      eventBus.$on("acceptProjectOffer", (data) => {
        let projectData = data;
        let offerData = this.preparedOfferData;
        let creds = {
          projectData: projectData,
          offerData: offerData,
        };
        this.acceptOfferProjectData({creds: creds})
      });
      eventBus.$on("acceptOfferSuccess", () => {
        this.showProjectFormModal = false;
        this.updateDataInFormIsChanged(false);
        this.searchOffers();
      });
      eventBus.$on("declineOfferSuccess", () => {
        let messageDeclineOffer = localStorage.getItem("messageDeclineOffer");
        let textDeclineOffer = localStorage.getItem("textDeclineOffer");
        this.getSnackBar(messageDeclineOffer, textDeclineOffer, "check_circle", "success");
        this.searchOffers();
        localStorage.removeItem("textDeclineOffer");
        localStorage.removeItem("messageDeclineOffer");
      });
      eventBus.$on("pendingOfferSuccess", (dataReceive) => {
        this.getSnackBar(dataReceive.title, dataReceive.message, "check_circle", "success");
        this.searchOffers();
      });
      eventBus.$on("operationOffer", (data, operation) => {
        if(operation === "download") {
          downloadFileHelper(data);
          this.downloadedOffers.splice(this.downloadedOffers.indexOf(data.id), 1);
        }
      });
      eventBus.$on('generateOfferPdfFailed', () => {
        this.downloadedOffers = [];
      })
      eventBus.$on('sendDocumentSuccess', (data) => {
        this.getSnackBar(data.message, data.data.textInfo, "check_circle", "success");
      })
    },
    beforeDestroy(){
      eventBus.$off('acceptProjectOffer')
      eventBus.$off('acceptOfferSuccess')
      eventBus.$off('importEstimation')
      eventBus.$off('sendDocumentSuccess')
      eventBus.$off('operationOffer')
    }
  }
</script>
